import { render, staticRenderFns } from "./cgStatistics.vue?vue&type=template&id=78d50038&scoped=true&"
import script from "./cgStatistics.vue?vue&type=script&lang=js&"
export * from "./cgStatistics.vue?vue&type=script&lang=js&"
import style0 from "./cgStatistics.vue?vue&type=style&index=0&id=78d50038&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d50038",
  null
  
)

export default component.exports